import type { FC } from 'react';
import { StaticImage } from 'gatsby-plugin-image';
import { Flex } from '@chakra-ui/react';

const images = [
  <StaticImage src='./assets/age-restrictions.png' alt='Age Restrictions' height={50} />,
  <StaticImage src='./assets/gamcare.png' alt='Gamcare' height={50} objectFit='contain' />,
  <StaticImage src='./assets/jogadores-anonimos.png' alt='Jogadores Anonimos' height={50} />,
  <StaticImage src='./assets/gazeus.png' alt='gazeus' height={50} objectFit='contain' backgroundColor='black' />,
  <StaticImage src='./assets/gordon-moody.svg' alt='Gordon Moody' height={50} backgroundColor='black' />,
];

const FooterExtra: FC = () => {
  return (
    <Flex as='ul' p={0} gap={4} flexWrap='wrap' direction='row-reverse' justifyContent='center'>
      {images.map((image, index) => (
        <Flex key={index} as='li' listStyleType='none'>
          {image}
        </Flex>
      ))}
    </Flex>
  );
};

export default FooterExtra;
